<template>
    <ModalFormCard class="modal-default" :action='"/admin/actions/subscription/" + subscription.id + "/extend"'>
        <template #title>Extend subscription</template>

        <template #default="{ saving, errors }">
            <p class='text-15 font-semibold'>Extend {{ subscription.company.getName() }}</p>
            <p class='text-14 text-grey-900 mt-2'>
                You are about to extend {{ subscription.company.getName() }} {{ subscription.location_area.name }} / {{ subscription.company.industry.name }} subscription. Only extend subscriptions if they are under performing or to change the subscription’s payment date.
            </p>

            <Select class='mt-4' name='reason'
                v-model:value='value.reason'
                label='Reason for extension' 
                placeholder='Select a reason'
                :options="[
                    { value: 'Poor performance' },
                    { value: 'Chaning payment date' },
                    { value: 'Other' },
                ]" 
            />

            <Textarea name='reason_other' v-model:value='value.reason_other' 
                label='Other reason' v-if='value.reason == "Other"' 
                class='mt-4'
            /> 
            
            <InputDropdownDatePicker
                v-model:value="value.trial_end"
                class="col-span-2 mt-4"
                input-class="!h-12"
                label="Extend until"
                name="date"
                placeholder="DD/MM/YYYY"
                :min='min'
                :max='32'
            />

            <InputCheckbox class='mt-4' name="accepted" value="1">
                <p class="text-14 text-grey-900 pl-2">This subscription's next payment will be taken on {{ value.trial_end }}. Are you sure you want to extend?</p>
            </InputCheckbox>

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Extend subscription
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                value: {
                    trial_end: null,
                    reason: null,
                    reason_other: '',
                }
            }
        },

        created() {
            this.value.trial_end = this.currentTrial.format('DD/MM/YYYY')
        },

        computed: {
            subscription() {
                return this.editingModel
            },

            currentTrial() {
                if (this.editingModel.stripe_trial_ends_at != null) {
                    return this.$moment(this.editingModel.stripe_trial_ends_at)
                }

                return this.$moment()
            },

            min() {
                return this.currentTrial.diff(this.$moment(), 'days')+1;
            },
        }
    }
</script>